import SEOMeta from '@/components/feature/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import HeroBanner from './components/HeroBanner';
import FeaturedManga from './components/FeaturedManga';
import LatestUpdates from './components/LatestUpdates';
import CategorySection from './components/CategorySection';
import FAQSection from './components/FAQSection';
import Footer from '@/components/feature/Footer';

const siteUrl = 'https://fanqiemanhua.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '番茄漫画',
  url: siteUrl,
  description: '番茄漫画追更漫画连载更新，提供最新话追漫提醒，免费全集完结韩漫日漫国漫，流畅下拉式滚动在线阅读体验，追漫必备。',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '番茄漫画',
  url: siteUrl,
  description: '番茄漫画 - 追更漫画连载更新平台，提供最新话追漫提醒，免费全集完结韩漫日漫国漫在线阅读。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@fanqiemanhua.com',
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <>
      <SEOMeta
        title="番茄漫画 - 追更漫画连载更新 | 最新话追漫提醒免费全集完结韩漫日漫国漫流畅下拉式滚动在线阅读"
        description="番茄漫画追更漫画连载更新，提供最新话追漫提醒，免费全集完结韩漫日漫国漫，流畅下拉式滚动在线阅读体验，追漫必备。每日更新热门日漫韩漫国漫资源。"
        keywords="番茄漫画,追更漫画,连载更新,最新话,追漫提醒,免费漫画,全集漫画,完结漫画,韩漫,日漫,国漫,下拉式阅读"
        canonicalUrl={siteUrl}
        ogImage="https://readdy.ai/api/search-image?query=Manga%20comic%20reading%20website%20banner%20with%20warm%20orange%20and%20red%20gradient%2C%20Japanese%20comic%20style%20art%20elements%2C%20modern%20clean%20web%20design%20aesthetic&width=1200&height=630&seq=fqmh-og-home&orientation=landscape"
        schema={{ ...homeSchema, ...orgSchema }}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturedManga />
        <LatestUpdates />
        <CategorySection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}